import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from './Button';

interface ErrorStateProps {
  message?: React.ReactNode;
  onRetry?: () => void;
}

const ErrorState: React.FC<ErrorStateProps> = ({ message, onRetry }) => {
  const { t } = useTranslation();
  return (
    <div
      className="flex flex-col items-center gap-3 rounded-2xl bg-school-danger-soft px-6 py-8 text-center"
      role="alert"
    >
      <p className="font-semibold text-school-danger">{message ?? t('school_error_generic')}</p>
      {onRetry && (
        <Button variant="secondary" icon="refresh" onClick={onRetry}>
          {t('school_retry')}
        </Button>
      )}
    </div>
  );
};

export default ErrorState;
